import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/v1/user';

export class UserServiceV1 implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  async createUser(params: types.CreateUserParameters) {
    await this.axios.post<void>(`/v1/users`, params.body);
  }

  async patchUserRequest(params: types.PatchUserRequestParameters): Promise<void> {
    const { data } = await this.axios.patch(`/v1/users/request/${params.path.token}`, params.body);
    return data;
  }

  async getCompanyAdminRequests(
    params: types.GetCompanyAdminRequestsParameters,
  ): Promise<types.GetCompanyAdminRequestsResponse> {
    const { data } = await this.axios.get(`/v1/users/company-admin-requests`);
    return data;
  }
}
